import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

//import constants
import { IS_MOBILE } from "../../../constants/breakpoints";

//import general components
import ActionButton from "./action-button";

function SelectedHotel({ title, star, selectedRoom, image, date, totalPrice, type, handleRemoveHotel }) {
    //general variables
    const { t } = useTranslation();

    const informationList = [
        { id: 1, title: t("roomName"), data: "name" },
        {
            id: 2,
            title: type === "intHotel" ? t("numberOfPeople") : t("capacity"),
            data: type === "intHotel" ? ["travelers.adult_count.index", "travelers.child_count.index"] : "capacity",
            label: t("person"),
            shouldSum: type === "intHotel", // Flag to indicate if we should sum the values
        },
        { id: 3, title: t("description"), data: type === "intHotel" ? "meal_type" : "planName" },
    ];
    const getNestedValue = (obj, path, indexKey) => {
        const actualPath = path.replace(/\.index$/, `.${indexKey + 1}`);
        return actualPath.split(".").reduce((acc, part) => acc?.[part], obj);
    };

    return (
        <Grid className={`${!IS_MOBILE && "selected-item"} `} container item xs={12} justifyContent="space-between" alignItems="center">
            <Grid container item md={10} rowGap={3}>
                <Grid className={IS_MOBILE ? "selected-item__title" : ""} component="span" container item xs={12} columnGap={1} alignItems="center">
                    <Grid component="img" className="selected-item__image" src={image} />
                    <Grid container item xs="auto" flexDirection="column" justifyContent="center">
                        <span>{title}</span>
                        <span className="selected-item__date">
                            {!!star && `${star} ${t("star")} - `}
                            {date}
                        </span>
                    </Grid>
                </Grid>

                {selectedRoom?.map((room, roomIndex) => {
                    return (
                        <Grid key={Math.random()} className="selected-item" container item xs={12} rowGap={2} columnGap={{ xs: 1, md: 8 }}>
                            {informationList.map(information => {
                                let value;
                                if (information.shouldSum && Array.isArray(information.data)) {
                                    // Sum multiple paths
                                    value = information.data.reduce((sum, path) => {
                                        const pathValue = getNestedValue(room, path, roomIndex);
                                        return sum + (Number(pathValue) || 0);
                                    }, 0);
                                } else {
                                    // Single path
                                    const dataPath = Array.isArray(information.data) ? information.data[0] : information.data;
                                    value = getNestedValue(room, dataPath, roomIndex);
                                }

                                return (
                                    <Grid key={information.id} container item xs={3.8} md={2} direction="column">
                                        <span className="selected-item__title-details">{information?.title}</span>
                                        <span className="selected-item__details">
                                            {value} {information?.label}
                                        </span>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    );
                })}
            </Grid>

            {!IS_MOBILE && <ActionButton text={t("editHotel")} price={totalPrice} handleRemove={handleRemoveHotel} />}
        </Grid>
    );
}

export default SelectedHotel;
